import {
  type ProductMediaAssetFormat,
  type ThumbnailFormat,
} from '@/modules/product/types.ts';

export function getLargestProductPictureFormat(
  formats: ProductMediaAssetFormat
): ThumbnailFormat {
  return [...Object.values(formats)].sort((a, b) => {
    if (a.width > b.width) {
      return -1;
    }
    if (a.width === b.width) {
      const urlSplitA = a.url.split('/');
      const lastItemA = urlSplitA[urlSplitA.length - 1];
      if (lastItemA.indexOf('P8') >= 0) {
        return -1;
      }
      return 1;
    }
    return 1;
  })[0];
}
